import axios from 'axios'
import Qs from 'qs'
import { MessageBox } from 'mint-ui'
import { getStore, getQueryString } from '../utils/util'

// 请求的配置信息
var config = {
  URL: 'https://zyfn.fengqianglife.com'
}

class Http {
  constructor (config) {
    this.axios = axios.create({
      baseURL: config.URL + '/zyapi'
    })
    this.URL = config.URL
    this.axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    this.interceptorsRequest() // 请求拦截器
    this.interceptorsResponse() // 响应拦截器
  }
  interceptorsRequest () { // 请求拦截器
    this.axios.interceptors.request.use((config) => {
      config.headers['openid'] = getStore('openid') // 用户登录的凭证
      config.headers['role'] = getStore('role') // 用户登录的凭证
      config.headers['sessiontoken'] = getStore('sessiontoken') // 用户登录的凭证
      return config
    }, function (error) {
      console.log(error)
      return Promise.reject(error)
    })
  }

  interceptorsResponse () { // 响应拦截器
    this.axios.interceptors.response.use((response) => {
      if (response.status === 200 && response.data.err_code === 202) { // 拦截未登录去登录操作
        var redirectURL
        if (getQueryString('shareid')) {
          redirectURL = encodeURIComponent(this.URL + '?shareid=' + getQueryString('shareid'))
        } else {
          redirectURL = encodeURIComponent(this.URL)
        }
        window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx56dfe2f445601aef&redirect_uri=' + redirectURL + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect')
      } else if (response.status === 200 && response.data.err_code === 1) {
        MessageBox.alert(response.data.message, '提示')
        return response.data
      } else {
        return response.data
      }
    }, function (error) {
      console.log(error, '&网络异常&')
      // 对响应错误做点什么
      return Promise.reject(error)
    })
  }

  get (url, params = {}) {
    return this.axios({
      method: 'get',
      url,
      params, // get 请求时带的参数
      timeout: 10000
    })
  }

  post (url, data = {}) {
    return this.axios({
      method: 'post',
      url,
      // params, // post 请求时带的参数
      data: Qs.stringify(data),
      timeout: 10000

    })
  }
}

export const http = new Http(config)



// WEBPACK FOOTER //
// ./src/http/api.js